import {Stack} from '@primer/react'
import {ForYouItemSkeleton} from '../for-you/shared/ForYouItemFallbacks'

export function CommentsAndReviewsSkeleton() {
  return (
    <Stack aria-label="Loading comments" direction="vertical" gap="normal" as="ul">
      {[1, 2, 3].map(key => (
        <ForYouItemSkeleton key={key} />
      ))}
    </Stack>
  )
}
